$(function() {
    // $("#roomVideo_html5_api").siblings("div").remove();
    // $("#roomVideo_html5_api").siblings("button").remove();

    if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {



        $('.vjs-default-skin').css("height", $(".min_live_div").height())

        $("#roomVideo_html5_api").css("maxwidth", $(window).width())

    } else {



    }
    // var timer = window.setInterval(func, 2000);
    // function func() {
    // 	$('#roomVideo_html5_api').parent().css("width", $(".video_live").width())
    // 	$('#roomVideo_html5_api').parent().css("height", $(".video_live").height())
    // }
    // window.clearInterval(timer);

})


// WEBPACK FOOTER //
// ./src/assets/js/establish.js